import React, { useState } from 'react';
import { Grid } from '@material-ui/core';

import { PasswordForm, OpinionForm, LeaveResult } from '../components/LeaveIdPage';

// 탈퇴 — 1단계 비밀번호 확인(이메일 회원) → 2단계 사유 → 완료. 확인한 비밀번호는 탈퇴 요청(PUT /v1/quit)에도 함께 보낸다
function LeaveIdPage(props) {
  const [page, setPage] = useState("pw");
  const [password, setPassword] = useState('');

  const handleCheck = (pageType, pw) => {
    if (pw !== undefined) setPassword(pw);
    setPage(pageType);
  }

  return (
    <React.Fragment>
      <Grid className="mainLayout" container direction="column" justify="center" alignItems="center">
        {page === 'pw' && <PasswordForm handleCheck={handleCheck}/> }
        {page === 'checked' && <OpinionForm handleCheck={handleCheck} password={password} /> }
        {page === 'result' && <LeaveResult /> }
        
      </Grid>
    </React.Fragment>
  );
}

export default LeaveIdPage;